import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterCommunications } from "./UseFooterCommunications";
import { useNavigate, useLocation } from "react-router-dom";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function AddCommunication() {
  const location = useLocation();
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { SetFooterCommunications, validateCommunicate } =
    UseFooterCommunications();
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );
  const [state, setState] = useState({
    type: undefined,
    title: undefined,
    visible: false,
    footerID: homePageId ? homePageId.id : 1,
  });
  const ImageType = [
    { id: 1, type: "1" },
    { id: 2, type: "2" },
  ];
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    title: false,
    type: false,
  });

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/footerManage",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت فوتر",
            url: "/footerManage",
          },
          {
            name: "افزودن لینک",
            url: "/footerManage/addLink",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 5"}>
          <TextField
            fullWidth
            value={state.title ? state.title : ""}
            label="عنوان"
            multiline
            maxRows={4}
            error={errorState.title}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, title: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <Autocomplete
            size="small"
            value={state.type ? state.type : ""}
            onChange={(event, newValue) => {
              setState({
                ...state,
                type: newValue,
              });
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return ImageType.find((m) => m.id == option).type;
              }
              return "";
            }}
            options={ImageType?.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                error={errorState.type}
                variant="outlined"
                {...params}
                label="نوع"
              />
            )}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 2"}>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.visible}
                onChange={(event) =>
                  setState({
                    ...state,
                    visible: event.target.checked,
                  })
                }
              />
            }
            label="نمایش"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (validateCommunicate(state, setErrorState) == 200) {
                setProgress(true);
                SetFooterCommunications(state, (calback) => {
                  navigate("/footerManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
